import React from 'react';
import iconPath from "./../../../helpers/iconHelper";


export default function IconDislike(prop) {
    
  return (
   <img src={iconPath['DISLIKE']} />
  );
}